<!--content accessories-->
<div class="container margine-ampio px-lg-0">
	<div class="my-5">
		<div class="text-center">
			<h1 class="titolo-bertazzoni">{{accessori}}</h1>
			<p class="didascalia-bertazzoni">You can refine your selection by using the filters at the top of the page.</p>
		</div>
	</div>
</div>

<!-- FILTERS -->
<div class="filter-bar mb-4">
	<div class="filter-bar-inner">
		<form id="filters" method="" action="">
			<div class="filters filters-primary">
				<div class="filters-row">
					<div class="title">
						Types
						<i class="fb-plus if-not-active"></i>
						<i class="fb-minus if-active"></i>
					</div>
					<ul class="menu menu-filters">
						<li *ngFor="let filtro of famiglie">
							<label class="label" [class.disabled]="filtro.disabled">
								<input
									class="checkbox"
									type="checkbox"
									name="famiglia{{filtro.valore}}"
									[disabled]="filtro.disabled"
									[ngModel]="filtro.selected"
									(ngModelChange)="filtra(filtro, $event)" />
								<span translate>{{filtro.valore}}</span>
							</label>
						</li>
					</ul>
				</div>
			</div>
			<div class="filters filters-secondary" id="filters-secondary" [style.max-height]="showColors ?  'unset' : 0">
				<div class="filters-row">
					<div class="title">
						Colors
						<i class="fb-plus if-not-active"></i>
						<i class="fb-minus if-active"></i>
					</div>
					<ul class="menu menu-filters">
						<li *ngFor="let filtro of colori" [class.d-none]="filtro.disabled">
							<label class="label">
								<input
									class="checkbox"
									type="checkbox"
									group="qColore"
									name="qColore_{{filtro.valore}}"
									[disabled]="filtro.disabled"
									[ngModel]="filtro.selected"
									(ngModelChange)="filtra(filtro, $event)" />
								<span class="filter-color" [style.background-color]="filtro.codiceHtml"></span>
								<span translate>{{filtro.valore}}</span>
							</label>
						</li>
					</ul>
				</div>
			</div>
			<div class="border-bottom py-3">
				<div class="justify-content-center d-flex">
					<button
						type="button"
						class="btn btn-bertazzoni black rounded-0 px-4 mr-3"
						[disabled]="!tipologiaSelezionata"
						(click)="showColors = !showColors">
						{{ showColors ? 'LESS FILTERS' : 'MORE FILTERS'}}
					</button>
					<button type="button" class="btn btn-bertazzoni black rounded-0 px-4" (click)="reset()">RESET</button>
				</div>
			</div>
		</form>
	</div>
</div>

<!-- Accessories -->
<div class="container px-lg-0 mt-5">
	<div class="my-5">
		<div class="text-center">
			<h1 class="titolo-bertazzoni"></h1>
		</div>
		<div class="row">
			<div class="col-12 col-md-6 col-lg-4 mt-4 card-category zoom" *ngFor="let accessorio of accessories">
				<div class="altezza-card">
					<div class="row card-category-img">
						<div class="col-md-10 col-12 text-center">
							<img
								*ngIf="accessorio.prodottiCommerciali[0].immagini.length > 0"
								[routerLink]="accessorio.prodottiCommerciali[0]?.codiceCommerciale | encodeUrl"
								[src]="accessorio.prodottiCommerciali[0].immagini[0]?.path | img"
								class="img-accessorio" />
							<img
								*ngIf="accessorio.prodottiCommerciali[0].immagini.length == 0"
								[routerLink]="accessorio.prodottiCommerciali[0]?.codiceCommerciale | encodeUrl"
								[src]="'assets/img/no-img.png'"
								class="img-accessorio" />
						</div>
						<!--CASE COLOR LIKE SIGLE OBJECT-->
						<div class="col-md-2 col-8 mt-lg-5 mx-auto d-flex d-md-block text-right justify-content-around align-items-center">
							<div
								class="cerchietto-2 my-2"
								[style.background-color]="accessorio.prodottiCommerciali[0].colore.codiceHtml"
								placement="left"
								[ngbTooltip]="accessorio.prodottiCommerciali[0].colore.idBertazzoni | translate"></div>
						</div>
						<!---->
						<!--CASE ARRAY OF COLORS
                        <div
                            class="col-md-2 col-8 mt-lg-5 mx-auto d-flex d-md-block text-right justify-content-around align-items-center">
                            <div *ngFor="let colore of accessorio.prodottiCommerciali[0].colore" class="cerchietto-2 my-2"
                                [style.background-color]="colore.codiceHtml" placement="left"
                                [ngbTooltip]="colore.idBertazzoni | translate"
                                (click)="accessorio.prodottiCommerciali = colore"></div>
                        </div>
                        -->
					</div>
					<div class="row">
						<div class="col-12 mt-4 px-4" [routerLink]="accessorio.prodottiCommerciali[0]?.codiceCommerciale">
							<p class="text-secondary mb-0">
								{{accessorio.prodottiCommerciali[0]?.codiceCommerciale}}
							</p>
							<p class="font-16 mb-0 font-semibold testo-3-linee" [ngbTooltip]="getDescrizione(accessorio)?.valore">
								<span *ngIf="isNew(accessorio)" class="is-new">New</span>
								{{getDescrizione(accessorio)?.valore}}
							</p>
							<ng-container *soloUsa>
								<p *ngIf="accessorio.prodottiCommerciali[0].giacenzaMagazzino > 0" class="font-14 mb-0 font-semibold text-success">
									{{accessorio.prodottiCommerciali[0].giacenzaMagazzino}} items available
								</p>
								<p *ngIf="accessorio.prodottiCommerciali[0].giacenzaMagazzino === 0" class="font-14 mb-0 font-semibold text-secondary">
									Unavailable
								</p>
							</ng-container>
							<ng-container *nonUsa>
								<p
									class="font-14 mb-0 font-semibold"
									style="color: red;"
									*ngIf="accessorio.prodottiCommerciali[0].statoGiacenza === 'IN_STOCK'">
									Product in phase-Out: {{accessorio.prodottiCommerciali[0].giacenza}} pcs. In Stock
								</p>
							</ng-container>
						</div>
					</div>
				</div>
				<div class="row">
					<div class="col-12 mt-4">
						<div class="bg-grey-my py-3 text-center">
							<p class="mb-0 font-20 text-white">
								{{ '' | valuta }}
								{{accessorio.prodottiCommerciali[0].listini[0]?.prezzoNetto *
                                accessorio.prodottiCommerciali[0].quantita | number}}
							</p>
						</div>
						<form #form="ngForm">
							<div class="d-flex">
								<div class="number-input">
									<div (click)="stepQuantita('-', accessorio.prodottiCommerciali[0])" class="selettore-spin"></div>
									<input
										class="quantity form-bertazzoni"
										min="0"
										max="100"
										name="quantity"
										value="1"
										type="number"
										[(ngModel)]="accessorio.prodottiCommerciali[0].quantita"
										required />
									<div (click)="stepQuantita('+', accessorio.prodottiCommerciali[0])" class="selettore-spin plus"></div>
								</div>
								<button
									class="btn btn-bertazzoni black btn-block rounded-0"
									[disabled]="form.invalid || accessorio.prodottiCommerciali[0].quantita == 0"
									(click)="buy(accessorio.prodottiCommerciali[0])">
									ADD TO CART
								</button>
							</div>
						</form>
					</div>
				</div>
			</div>
		</div>
		<hr class="mt-5" />
	</div>
</div>
